<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters>
        <image-row :title="topTitle" config="page-press" />
      </v-row>
      <div class="contact-wrapper">
        <div class="contact-content">
          <div class="contact-icon-wrapper">
            <img class="contact-icon" src="https://storage.googleapis.com/mwm-website-v2-content/press/combined-shape.svg" />
          </div>
          <div class="contact-title-wrapper">
            <span class="contact-title">{{ contactTitle }}</span>
          </div>
          <div class="contact-text-wrapper">
            <span class="contact-text">{{ contactText }}</span>
          </div>
          <div class="contact-name-wrapper">
            <span class="contact-name">{{ contactName }}</span>
          </div>
          <div class="contact-email-wrapper">
            <a :href="`mailto:${contactEmail}`">
              <span class="contact-email">{{ contactEmail }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="release-wrapper">
        <div class="release-content">
          <div class="release-title-wrapper">
            <span class="release-title">{{ releaseTitle }}</span>
          </div>
          <div class="release-card-wrapper">
            <v-card class="release-card">
              <div class="release-card-badge-wrapper">
                <div class="release-card-badge">
                  <span class="release-card-badge-text">{{ releaseCardBadgeText }}</span>
                </div>
              </div>
              <img class="release-card-image" src="https://storage.googleapis.com/mwm-website-v2-content/press/mwm-team.jpg" >
              <div class="release-card-title-wrapper">
                <span class="release-card-title">{{ releaseCardText }}</span>
              </div>
            </v-card>
          </div>
          <div class="release-button-wrapper">
            <v-btn height="54" :ripple="false" class="release-button" @click="openUrl(pressReleaseUrl)">
              <span class="release-button-text">{{ releaseButtonText }}</span>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="pictures-wrapper">
        <div class="pictures-content">
          <div class="pictures-title-wrapper">
            <span class="pictures-title">{{ picturesTitle }}</span>
          </div>
          <img v-if="isMobile" class="pictures-patchwork-wrapper" height="1110" src="https://storage.googleapis.com/mwm-website-v2-content/press/patchwork-mobile.jpg" >
          <v-row v-else no-gutters class="pictures-patchwork-wrapper" justify="center">
            <div class="pictures-patchwork">
              <v-img contain eager src="https://storage.googleapis.com/mwm-website-v2-content/press/patchwork.jpg" />
            </div>
          </v-row>
          <div class="pictures-button-wrapper">
            <v-btn height="54" :ripple="false" class="pictures-button" @click="openUrl(mediaKitUrl)">
              <span class="pictures-button-text">{{ picturesButtonText }}</span>
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="!isMobile" class="press-logos-wrapper">
        <div class="press-logos-content">
          <img v-for="i in 6" class="press-logo" :key="i" :src="'https://storage.googleapis.com/mwm-website-v2-content/press/b' + i + '.png'" /><br/>
          <img v-for="i in 6" class="press-logo" :key="6+i" :src="'https://storage.googleapis.com/mwm-website-v2-content/press/b' + (6+i) + '.png'" />
        </div>
      </div>
      <v-img v-else eager class="press-logos" src="https://storage.googleapis.com/mwm-website-v2-content/press/logos-press.jpg" />
    </v-col>
  </v-row>
</template>

<script>
import SizeHolder from '@/mixins/SizeHolder.vue';

import ImageRow from './components/ImageRow.vue'

export default {
  mixins: [SizeHolder],
  components: {
    'image-row': ImageRow,
  },
  data: () => ({
    topTitle: 'For Media',

    contactTitle: 'Contact us',
    contactText: 'For all PR inquiries or interview requests, please contact us: ',
    contactName: 'Ariane STEINMETZ',
    contactEmail: 'ariane@musicworldmedia.com',

    releaseTitle: 'Last News',
    releaseCardText: 'MWM raises €50 Million',
    releaseCardBadgeText: '03/03/2020',
    releaseButtonText: 'Read the Press Release',

    picturesTitle: 'Some pictures',
    picturesButtonText: 'Download Media Kit',

    pressReleaseUrl: 'https://storage.googleapis.com/mwm-website-v2-content/press/mwm-press-release.zip',
    mediaKitUrl: 'https://projects.invisionapp.com/boards/KX3YNHUPMW7/#/6655602',
  }),
  methods: {
    openUrl (url) {
      const win = window.open(url, '_blank');
      win.focus();
    },
  },
  computed: {

  },
  mounted () {

  }
};
</script>

<style scoped lang="scss">
@media (max-width: 960px) {
  .contact-content {
    height: 70vh;
  }

  .release-card {
    width: 75%!important;
  }

  .release-card-badge {
    width: 60px!important;
    height: 29px!important;
  }

  .release-card-badge-wrapper {
    top: 1.3rem!important;
    left: 1.3rem!important;
  }

  .release-card-badge-text {
    font-size: 14px!important;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .release-card-title {
    font-size: 24px!important;
  }
}

@media (max-width: 560px) {
  .release-card-badge {
    width: 50px!important;
    height: 19px!important;
  }

  .release-card-badge-wrapper {
    top: 1rem!important;
    left: 1rem!important;
  }

  .release-card-badge-text {
    font-size: 12px!important;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .release-card-title {
    font-size: 16px!important;
  }
}

.contact-wrapper {
  display: table;
  width: 100%;
  height: 55vh;
  margin-right: auto;
  margin-left: auto;
  background-image: linear-gradient(to right, #ff7854 82%, #8e0eb3 2%);
  background-image: -webkit-gradient(linear, left top, right top, color-stop(82%, #ff7854), color-stop(2%, #8e0eb3));
}

.contact-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.contact-icon-wrapper {
  width: 6.2rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  border-radius: 15.6px;
  box-shadow: 0 4px 17px 0 rgba(0, 0, 0, 0.08);
  background-color: #fdfdff;
  margin: auto;
}

.contact-icon {
  margin: auto;
}

.contact-title-wrapper {
  margin-top: 2rem;
}

.contact-title {
  font-family: CenturyGothic;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}

.contact-text-wrapper {
  margin-top: 2rem;
}

.contact-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
}

.contact-name-wrapper {
  margin-top: 2rem;
}

.contact-name {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
}

.contact-email-wrapper {

}

.contact-email {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  text-decoration: underline;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
}

.release-wrapper {
  display: table;
  width: 100%;
  height: 55vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #f4f5f5;
}

.release-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.release-title-wrapper {
  margin-top: 4rem;
}

.release-title {
  font-family: CenturyGothic;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  color: #212a39;
}

.release-card-wrapper {
  margin-top: 4rem;
}

.release-card {
  border-radius: 36px!important;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.release-card-image {
  width: 100%;
  height: auto;
  border-top-left-radius: 36px!important;
  border-top-right-radius: 36px!important;
}

.release-card-badge-wrapper {
  position: absolute;
  display: table;
  z-index: 1;
  top: 2rem;
  left: 2rem;
}

.release-card-badge {
  display: table-cell;
  vertical-align: middle;
  width: 130px;
  height: 39px;
  border-radius: 20px;
  background-color: #ff0067;
}

.release-card-badge-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.release-card-title-wrapper {
  margin-top: 3rem;
  padding-bottom: 3rem;
}

.release-card-title {
  font-family: CenturyGothic;
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.release-button-wrapper {
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.release-button {
  width: 280px;
  text-transform: unset;
  letter-spacing: unset;
  border-radius: 27px;
  background-image: -webkit-gradient(linear, left top, right bottom, color-stop(34%, #ff7854), color-stop(109%, #ff0067));
  background-image: linear-gradient(to right, #ff7854 34%, #ff0067 109%);
}

.release-button-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}

.pictures-wrapper {
  display: table;
  width: 100%;
  height: 55vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
}

.pictures-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.pictures-title-wrapper {
  margin-top: 6rem;
}

.pictures-title {
  font-family: CenturyGothic;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  color: #212a39;
}

.pictures-patchwork-wrapper {
  margin-top: 4rem;
}

.pictures-patchwork {
  width: 50%;
}

.pictures-button-wrapper {
  margin-top: 5rem;
  margin-bottom: 4rem;
}

.pictures-button {
  width: 280px;
  text-transform: unset;
  letter-spacing: unset;
  border-radius: 27px;
  background-image: -webkit-gradient(linear, left top, right bottom, color-stop(34%, #ff7854), color-stop(109%, #ff0067));
  background-image: linear-gradient(to right, #ff7854 34%, #ff0067 109%);
}

.pictures-button-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}

.press-logos-wrapper {
  display: table;
  width: 80%;
  height: 40vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
}

.press-logos-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.press-logo {
  height: 100px;
  width: auto;
  margin-left: 1rem;
  margin-right: 1rem;
}

.press-logos {
  width: 80%;
  height: auto;
  margin: auto;
}
</style>
